module.exports = __webpack_public_path__ + "img/contact-3.3ab9f6b2.jpg";